import React, { PureComponent } from "react";
import Header from "../../../Header";
import LeftPanel from "../../../LeftPanel";
import ProjectDetailsCentralPanelContainer from "../Project/ProjectCentralPanelContainer";
import ProjectParticipantsCentralContainer from "../Project/ProjectParticipantsCentralContainer";
import ParticipantsFeedbackContainer from "../Project/ProjectFeedbackCentralContainer";
import {
  setApplications,
  setParticipants,
} from "../../../reducer/project/applicantReducer";
import { connect } from "react-redux";
import { authService } from "../../../auth";
import axios from "axios";
import NotFound from "../../../404";
import mappingUtils from "../../component/commons/utils/mappingUtils";
import * as _ from "lodash";
import {
  adminFlagData,
  convertUnicode,
  getCDNUrl,
  getFileIcon,
  getVolunterProjectName,
  isWebView,
  postMsg,
  redirectToProfilePage,
} from "../../../commons/CommonFunctions";
import dateUtil from "date-and-time";
import Linkify from "react-linkify";
import * as FileSaver from "file-saver";
import AuthModalComponent from "../../../LoginExtra/AuthModalComponent";
import { NavLink } from "react-router-dom";
import { renderToString } from "react-dom/server";
import ProjectFacultyContainer from "./ProjectFacultyContainer";
import BypassHeader from "../../../BypassHeader";
import UnauthProjectPrivate from "./UnauthProjectPrivate";
import PrivateProfile from "../../../profile/container/profile/PrivateProfile";
import ProjectAdminContainer from "./ProjectAdminContainer";
import SignUpModal from "../../../SignUpModal/signUpModal";
import LeftPanelUnauth from "../../../commons/LeftPanelUnauth";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ProjectFeeds from "../../../UnauthProject/projectFeeds";
import HideInfoPage from "../../../static/HideInfoPage";
import ProjectSettingsContainer from "../Project/ProjectSettingsContainer";
import PrivateProjectHidePage from "../../../static/PrivateProjectHidePage";
import ProjectStudioContainer from "./ProjectStudioContainer";
import { projectPageClickRequest } from "../../../reducer/projectPageClick/projectPageClick";
import ProjectStatsContainer from "./ProjectStatsContainer";
import ProjectHomeContainer from "./ProjectHomeContainer";
import { setProfileBasicInfoDetails } from "../../../reducer/profile/ProfileReducer";
import CleverTapUtils from "../../../commons/CleverTapUtils";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const componentDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank">
    {text}
  </a>
);

const TAB = {
  HOME: "home",
  FEED: "feeds",
  STUDIO: "studio",
  PARTICIPANT: "participants",
  FEEDBACK: "feedback",
  FACULTY: "faculty",
  ADMIN: "admin",
  STATS: "stats",
  SETTINGS: "settings",
};

class ProjectDetails extends PureComponent {
  state = {
    selectedTab: TAB.HOME ,
    projectId: undefined,
    userData: authService.getUserDetailsFromLocalStorage(),
    loginSuccess: authService.isAuthenticated(),
    projectDetail: {},
    notFoundstatusCode: "",
    lastDateOfApplication: "",
    loginRequired: false,
    signUpRequired: false,
    projectResponseMessage: "",
    userId: "",
    initialRender: true
  };

  handleApply(slug) {
    this.setState({ loginRequired: true, pathname: slug });
    window.$("#loginModal").modal("show");
  }

  loginRequired = (slug) => {
    this.setState({ loginRequired: true, pathname: slug });
    window.$("#loginModal").modal("show");
  };
  handleLoginClose = () => {
    this.setState({ loginRequired: false });
    window.$("#loginModal").modal("hide");
  };
  signUpRequired = () => {
    this.setState({ signUpRequired: true });
    window.$("#signupModal").modal("show");
  };
  handleSignUpClose = () => {
    this.setState({ signUpRequired: false });
    window.$("#signupModal").modal("hide");
  };

  componentDidMount() {
    let type = this.props.match.params.type || "feeds";
    if (type !== this.state.selectedTab) {
      this.onSelectionChange(this.state.selectedTab);
    }
    if (!this.state.loginSuccess) {
      this.getUnauthProjectDetails();
    } else {
      this.getProjectDetail();
    }
    if(this.props.location?.state?.showActivyTab) {
      this.onSelectionChange("feeds");
    }
    CleverTapUtils.eventClick({}, "View Project");
  }

  getUnauthProjectDetails = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/unauth/find-project-description-details-by-slug/" +
        this.props.match.params.projectId,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "200 OK") {
          this.setState({ projectDetail: res.body }, () => {
            if (this.state.projectDetail && this.state.projectDetail.project) {
              if (this.state.projectDetail.project.assignmentTitle) {
                document.title =
                  this.state.projectDetail.project.assignmentTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.sessionTitle) {
                document.title =
                  this.state.projectDetail.project.sessionTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.jobTitle) {
                document.title =
                  this.state.projectDetail.project.jobTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              }
            }
          });
          if ((this.state.projectDetail.detailPageVisible && this.state.projectDetail.demolishedType !== "DELETED" && this.state.projectDetail.demolishedType !== "CANCELLED") || adminFlagData()) {
            window.$("#projectDetails").modal("show");
          }
        }
      })
      .catch((err) => {
        if (err && err.response) {
          this.setState({
            notFoundstatusCode: err.response.status,
            error: { message: err.response.data.message, err: err.response },
          });
        }
        this.setState({
          isLoaded: true,
        });
      });
  };

  getProjectDetail = () => {
    let uid = this.props.location?.state?.userId ? this.props.location?.state?.userId : authService.getUserDetailsFromLocalStorage().userId;
    axios({
      method: "get",
      url: `${process.env.REACT_APP_userServiceURL}/participants/find-project-description-details-by-userId-and-slug/${uid}/${this.props.match.params.projectId}`,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "200 OK") {
          this.setState({ projectDetail: res.body,projectResponseMessage: res.message, userId: this.props.location?.state?.userId}, () => {
            this.props.projectPageClickRequest({"projectId": this.state.projectDetail.id || this.state.projectDetail.projectId, "userId": this.state.userId, "type": "PROJECT"});
            if (this.state.projectDetail && this.state.projectDetail.project) {
              if (this.state.projectDetail.project.assignmentTitle) {
                document.title =
                  this.state.projectDetail.project.assignmentTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.sessionTitle) {
                document.title =
                  this.state.projectDetail.project.sessionTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.jobTitle) {
                document.title =
                  this.state.projectDetail.project.jobTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              }
            }
            // if (
            //   this.state.projectDetail.participationDetails &&
            //   (this.state.projectDetail.participationDetails.secondaryEntityType === "JOB")
            // ) {
            //   this.onSelectionChange(TAB.PARTICIPANT);
            // }
          });
        }
      })
      .catch((err) => {
        if (err && err.response) {
          this.setState({
            notFoundstatusCode: err.response.status,
            error: { message: err.response.data.message, err: err.response },
          });
        }
        this.setState({
          isLoaded: true,
        });
      });
  };

  componentWillUnmount() {
    window.$("#projaddjob").modal("hide");
    window.$("#projaddevent").modal("hide");
    window.$("#projaddassignment").modal("hide");
    window.$("#projaddtraining").modal("hide");
    window.$("#addpostpop").modal("hide");
    window.$("#projectDetails").modal("hide");
    window.$("#toppostwrap").modal("hide");
    window.$("#postblog").modal("hide");
    window.$("#postlink").modal("hide");
    window.$("#blogpostpreviewwrap").modal("hide");
    window.$("#projaddoffLine").modal("hide");
    window.$("#postSelectUserModal").modal("hide");
  }

  onSelectionChange = (selectedTab) => {
    this.setState({ selectedTab });
  };

  componentWillReceiveProps(props) {
    let type = this.props.match.params.type || "feeds";
    if (type !== this.state.selectedTab && this.state.initialRender) {
      //this.onSelectionChange(this.state.projectDetail?.participationDetails?.secondaryEntityType !== "JOB" ? TAB.HOME : this.state.projectDetail?.participantTabVisible ? TAB.PARTICIPANT : this.state.projectDetail?.guestFacultyTabVisible ? TAB.FACULTY : this.state.projectDetail?.adminTabShow ? TAB.ADMIN : this.state.projectDetail?.managePermissionTabShow ? TAB.SETTINGS : this.state.projectDetail.statsTabShow ? TAB.STATS : TAB.HOME);
      this.setState({ initialRender: false })
      this.onSelectionChange(this.state.projectDetail?.participationDetails?.secondaryEntityType !== "JOB" ? TAB.FEED : TAB.HOME);
      //this.onSelectionChange(this.state.selectedTab);
    }
    if (this.props.match.params.projectId && this.props.match.params.projectId !== this.state.projectId) {
      this.setState({ projectId: this.props.match.params.projectId });
    }
  }

  getCentralPanelContentForJob = () => {
    if (
      this.state.selectedTab === TAB.HOME &&
      this.state.projectDetail.projectId
    ) {
      return (
        <ProjectHomeContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          slug={this.props.match.params.projectId}
        />
      );
    } else if (
      this.state.selectedTab === TAB.PARTICIPANT &&
      this.state.projectDetail.projectId
    ) {
      return (
        <ProjectParticipantsCentralContainer
          changeTab={this.onSelectionChange}
          key={this.state.projectDetail.projectId}
          projectId={this.state.projectDetail.projectId}
          type={
            this.state.projectDetail &&
            this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType
          }
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
        />
      );
    } else if (this.state.selectedTab === TAB.ADMIN) {
      return (
        <ProjectAdminContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectId={this.state.projectDetail.projectId}
          type={
            this.state.projectDetail &&
            this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType
          }
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
        />
      );
    } else if (this.state.selectedTab === TAB.STATS) {
      return (
        <ProjectStatsContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
        />
      );
    } else if (this.state.selectedTab === TAB.SETTINGS) {
      return (
        <ProjectSettingsContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
        />
      );
    }
  };

  getCentralPanelContent = () => {
    if (
      this.state.selectedTab === TAB.HOME &&
      this.state.projectDetail.projectId
    ) {
      return (
        <ProjectHomeContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          slug={this.props.match.params.projectId}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.FEED) {
      return (
        <ProjectDetailsCentralPanelContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          slug={this.props.match.params.projectId}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.STUDIO) {
      return (
        <ProjectStudioContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
        />
      );
    } else if (this.state.selectedTab === TAB.PARTICIPANT) {
      return (
        <ProjectParticipantsCentralContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectId={this.state.projectDetail.projectId}
          type={
            this.state.projectDetail &&
            this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType
          }
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.FACULTY) {
      return (
        <ProjectFacultyContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectId={this.state.projectDetail.projectId}
          type={
            this.state.projectDetail &&
            this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType
          }
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.ADMIN) {
      return (
        <ProjectAdminContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          projectId={this.state.projectDetail.projectId}
          type={
            this.state.projectDetail &&
            this.state.projectDetail.participationDetails &&
            this.state.projectDetail.participationDetails.secondaryEntityType
          }
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          active={this.state.selectedTab}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.FEEDBACK) {
      return (
        <ParticipantsFeedbackContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.STATS) {
      return (
        <ProjectStatsContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          userId={this.state.userId}
        />
      );
    } else if (this.state.selectedTab === TAB.SETTINGS) {
      return (
        <ProjectSettingsContainer
          key={this.state.projectDetail.projectId}
          changeTab={this.onSelectionChange}
          active={this.state.selectedTab}
          projectDetail={this.state.projectDetail}
          project={this.state.projectDetail}
          userId={this.state.userId}
        />
      );
    }
  };

  nFormatter = (num, digits) => {
    if (!num) {
      return num;
    }
    var si = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  };

  redirectToProfile = (customUrl) => {
    window.location.href = "/profile/" + customUrl;
  };

  download_file_pdf = (evt, url) => {
    evt.preventDefault();
    //let filename = this.getFileNameFromUrl(url);
    var parsedUrl = url.substring(url.lastIndexOf("/") + 1);
    let filename = parsedUrl.substring(parsedUrl.indexOf("-") + 1);

    FileSaver.saveAs(url, filename);
  };

  render() {
    var utcSeconds = this.state.projectDetail.dateOfPosting;
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds / 1000);

    let noOfDaysPosted = mappingUtils.getNoOfDaysAfterPosted(
      this.state.projectDetail && this.state.projectDetail.dateOfPosting
    );
    let title =
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      this.state.projectDetail.project.title;
    let location =
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      this.state.projectDetail.project.location;
    let fees =
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      this.state.projectDetail.project.cost;

    let attachments = [];
    if (
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      this.state.projectDetail.project.attachments &&
      this.state.projectDetail.project.attachments.length > 0
    ) {
      let attachedFiles = this.state.projectDetail.project.attachments;
      attachedFiles.map((data, index) => {
        let value = {
          name: data.substring(data.lastIndexOf("/") + 1),
          url: data,
        };
        attachments.push(value);
      });
    }
    let showProjectType;
    let projectType =
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.projectType;
    let secondaryEntityType =
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType;
    if (
      secondaryEntityType &&
      projectType &&
      !_.isNull(secondaryEntityType) &&
      !_.isNull(projectType)
    ) {
      if (projectType.toUpperCase() === "VOLUNTEER") {
          showProjectType = getVolunterProjectName(secondaryEntityType);
      } else {
        showProjectType = projectType;
      }
    } else {
      showProjectType = projectType;
    }

    let role =
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      (this.state.projectDetail.project.jobRole ||
        this.state.projectDetail.project.assignmentRole);
    let qualifications =
      this.state.projectDetail &&
      this.state.projectDetail.project &&
      (this.state.projectDetail.project.qualifications ||
        this.state.projectDetail.project.qualificationRequired);
    let typeContent;
    if (
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType ===
        "EVENT"
    ) {
      typeContent = "Mementos or Event Kits";
    } else if (
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType ===
        "JOB"
    ) {
      typeContent = "Remarks";
    } else if (
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType ===
        "ASSIGNMENT"
    ) {
      typeContent = "Certification or Accolades";
    } else if (
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType ===
        "TRAINING"
    ) {
      typeContent = "Certification or Accolades";
    } else if (
      this.state.projectDetail &&
      this.state.projectDetail.participationDetails &&
      this.state.projectDetail.participationDetails.secondaryEntityType ===
        "EXPEDITION"
    ) {
      typeContent = "Mementos or Event Kits";
    }

    let endDate = "";

    if (this.state.projectDetail && this.state.projectDetail.endDate > 0) {
      endDate = dateUtil.format(
        new Date(this.state.projectDetail.endDate),
        "DD MMM YYYY"
      );
    } else {
      endDate = "NA";
    }
    if (
      !this.state.loginSuccess &&
      this.state.projectDetail.detailPageVisible === false
    ) {
      return (
        <>
          <PrivateProfile />
        </>
      );
    }
    if (!this.state.loginSuccess && (this.state.notFoundstatusCode === 404 || (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction))) {
      return (
        <div className={"projectpage"}>
          <div className="wrapper nologinpage staticPage p404">
            <BypassHeader />
            <main className="dgcontainer hm3col">
              <div className="container">
                {this.state.notFoundstatusCode === 404 ? <HideInfoPage deletePost={true} /> : 
                (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) ? <PrivateProjectHidePage /> : null}
              </div>
            </main>
            {!this.state.loginSuccess ? (
              <LeftPanelUnauth signUpRequired={this.signUpRequired} />
            ) :(
              <LeftPanel communityActive={this.state.projectDetail?.partyType === "CIRCLE"} />
            )}
            {this.state.loginRequired === true ? (
              <AuthModalComponent
                handleLoginClose={this.handleLoginClose}
                pathname={this.state.pathname}
                history={this.props.history}
              />
            ) : null}
            {this.state.signUpRequired === true ? (
              <SignUpModal
                handleSignUpClose={this.handleSignUpClose}
                history={this.props.history}
              />
            ) : null}
          </div>
        </div>
      );
    } else if (!this.state.loginSuccess) {
      if ((this.state.notFoundstatusCode === 404 ||
        (this.state.projectDetail && this.state.projectDetail.hidden === true) || 
        (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) || this.state.projectDetail.demolishedType === "DELETED" || this.state.projectDetail.demolishedType === "CANCELLED") && !adminFlagData()
      ) {
        return(
          <>
            <div className={"projectpage"}>
              <div className="wrapper nologinpage staticPage p404">
                <BypassHeader />
                <main className="dgcontainer hm3col">
                  <div className="container">
                    {this.state.notFoundstatusCode === 404 ||
                      (this.state.projectDetail && (this.state.projectDetail.demolishedType === "DELETED" || this.state.projectDetail.demolishedType === "CANCELLED")) ? <HideInfoPage deletePost={true} projectDelete={true} /> :
                      (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction || this.state.projectDetail.hidden) ? <PrivateProjectHidePage myStudioPage={this.state.projectDetail.hidden ? true : false} /> : null}
                  </div>
                </main>
                {!this.state.loginSuccess ? (
                  <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                ) : (
                  <LeftPanel communityActive={this.state.projectDetail?.partyType === "CIRCLE"} />
                )}
                {this.state.loginRequired === true ? (
                  <AuthModalComponent
                    handleLoginClose={this.handleLoginClose}
                    pathname={this.state.pathname}
                    history={this.props.history}
                  />
                ) : null}
                {this.state.signUpRequired === true ? (
                  <SignUpModal
                    handleSignUpClose={this.handleSignUpClose}
                    history={this.props.history}
                  />
                ) : null}
              </div>
            </div>
          </>
        );
      } else {
        let linkfiedHtml1 =
          '<p class="pdtlsLink">' +
          renderToString(
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              {location && location.address
                ? location.address
                    .replace(/<br\/>/g, "\n")
                    .replace(/&nbsp;/g, " ")
                : ""}
            </Linkify>
          )
            .replace(/&nbsp;/g, " ")
            .replace(/(\r\n|\r|\n)/g, "<br>")
            .replace(/(\\n)/g, "<br>") +
          "</p>";

        return this.state.projectDetail?.participationDetails
          ?.secondaryEntityType === "JOB" ||
          !this.state.projectDetail?.feedsAvailable ? (
          <div className="authModalBg loginwrap">
            <UnauthProjectPrivate />
            <div
              id="projectDetails"
              className="modal fade dgpopup authLoginModal"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="projectdescwrap">
                      <NavLink to="/">
                        <button className="close"><i className="iCross"></i></button>
                      </NavLink>
                      <div className="projdestopbar">
                        <h1>{showProjectType}</h1>
                        <ul>
                          {this.state.projectDetail &&
                            this.state.projectDetail.demolished === false && (
                              <li className="posted">
                                {noOfDaysPosted === 0 ||
                                noOfDaysPosted === "0" ? (
                                  <span>Posted Today</span>
                                ) : (
                                  <span>
                                    Posted {dateUtil.format(new Date(this.state.projectDetail?.project?.createTime), "DD MMM YYYY")}
                                  </span>
                                )}
                              </li>
                            )}
                        </ul>
                      </div>
                      <div className="projdesheader">
                        <div className="row">
                          <div className="col-lg-4 jobsblk">
                            <span>Title</span>
                            <h4>{unescape(title)}</h4>
                            <p className="addRss">
                              <i className="iLocation"></i>
                              <span>
                                {location && location.city},{" "}
                                {location && location.state},{" "}
                                {location && location.country}
                              </span>
                            </p>
                            {this.state.projectDetail &&
                              this.state.projectDetail.project &&
                              this.state.projectDetail.project.isDisclosed ==
                                false &&
                              fees > 0 && (
                                <div className="price">
                                  <i className="iWallet"></i>{" "}
                                  {this.state.projectDetail.project.currency}{" "}
                                  {this.nFormatter(fees, 2)}{" "}
                                  {!_.isNull(
                                    this.state.projectDetail.project.packageType
                                  ) &&
                                    !_.isUndefined(
                                      this.state.projectDetail.project
                                        .packageType
                                    ) &&
                                    this.state.projectDetail.project.packageType.toLowerCase() !==
                                      "custom" &&
                                    this.state.projectDetail.project
                                      .packageType}
                                  <span>
                                    {this.state.projectDetail.project
                                      .isNegotiable && "(Negotiable)"}
                                  </span>
                                </div>
                              )}
                          </div>
                          <div className="col-lg-4 recruiter">
                            <span>Creator</span>
                            <div className="recruitblk">
                              {this.state.projectDetail &&
                                this.state.projectDetail.creatorName && (
                                  <div
                                    className="recruit"
                                    onClick={(e)=> {e.preventDefault();redirectToProfilePage(this.state.projectDetail.customUrl,this.state.projectDetail.partyType)}}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <figure
                                      className="complogo"
                                      onClick={(e)=> {e.preventDefault();redirectToProfilePage(this.state.projectDetail.customUrl,this.state.projectDetail.partyType)}}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={
                                          !_.isUndefined(
                                            this.state.projectDetail &&
                                              this.state.projectDetail.imageUrl
                                          ) &&
                                          !_.isNull(
                                            this.state.projectDetail &&
                                              this.state.projectDetail.imageUrl
                                          )
                                            ? getCDNUrl(
                                                this.state.projectDetail &&
                                                  this.state.projectDetail
                                                    .imageUrl
                                              )
                                            : this.state.projectDetail &&
                                              this.state.projectDetail
                                                .userType == "INDIVIDUAL"
                                            ? "https://cdn.dscovr.com/images/users1.png"
                                            : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                                        }
                                        alt=""
                                      />
                                    </figure>
                                    {this.state.projectDetail &&
                                      this.state.projectDetail.creatorName}
                                  </div>
                                )}
                            </div>
                            {this.state.projectDetail &&
                              this.state.projectDetail.project &&
                              this.state.projectDetail.project.companyName &&
                              !_.isNull(
                                this.state.projectDetail.project.companyName
                              ) &&
                              this.state.projectDetail.project.companyName !==
                                "null" && (
                                <>
                                  <span>Organization</span>
                                  <div className="recruit">
                                    {/*<figure className="complogo">
                                        <img src={coverImage} alt=""/>
                                    </figure>*/}
                                    <span>
                                      {unescape(
                                        this.state.projectDetail.project
                                          .companyName
                                      )}
                                    </span>
                                  </div>
                                </>
                              )}
                            {this.state.projectDetail &&
                              this.state.projectDetail.project &&
                              this.state.projectDetail.project.websiteLink &&
                              this.state.projectDetail.project
                                .websiteLink[0] !== "" && (
                                <p>
                                  <a
                                    onClick={(event) =>
                                      window.open(
                                        this.state.projectDetail.project
                                          .websiteLink[0]
                                          ? mappingUtils.sanitize(
                                              this.state.projectDetail.project
                                                .websiteLink[0]
                                            )
                                          : mappingUtils.sanitize(
                                              this.state.projectDetail.project
                                                .websiteLink[0]
                                            ),
                                        "_blank"
                                      )
                                    }
                                    href="javascript:void(0)"
                                  >
                                    <i className="iGlobe" /> Website
                                  </a>
                                </p>
                              )}
                          </div>
                          {this.state.projectDetail && this.state.projectDetail.isOffLine === false && this.state.projectDetail.demolished === false && (
                              <div className="col-lg-4 opening">
                                {(this.state.projectDetail.participationDetails.secondaryEntityType !== "FUNDRAISE" || (this.state.projectDetail.participationDetails.secondaryEntityType === "FUNDRAISE" && this.state.projectDetail.lastDateOfApplication !== 0)) && 
                                    <>
                                      <span>Application</span>
                                      <p> Last date:{" "} {dateUtil.format(new Date(this.state.projectDetail.lastDateOfApplication), "DD MMM YYYY")}</p>
                                      {this.state.projectDetail && this.state.projectDetail.noOfOpenings && this.state.projectDetail.noOfOpenings > 0 ? 
                                        <p>
                                          Openings:{" "}
                                          {this.state.projectDetail && this.state.projectDetail.noOfOpenings && this.state.projectDetail.noOfOpenings}
                                        </p> : <></>
                                      }
                                    </>
                                }
                                {this.state.projectDetail && this.state.projectDetail.noOfOpenings && this.state.projectDetail.noOfOpenings > 0 && this.state.projectDetail.stage !== 'completed' ?
                                    <div className="buttblk">
                                      <a href="javascript:void(0)" className="btn btn-primary" onClick={(e) => this.handleApply(`/project/feeds/${this.state.projectDetail.slug}`)}>
                                        {this.state.projectDetail.participationDetails.secondaryEntityType !== "FUNDRAISE" ? "Apply" : "Contribute"}
                                      </a>
                                    </div> : 
                                    <></>
                                }
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="projdesbody">
                        <div className="projdesbodyinn">
                          <div className="largetext">
                            <h5>Brief Description</h5>
                            <p>
                              <Linkify
                                componentDecorator={(
                                  decoratedHref,
                                  decoratedText,
                                  key
                                ) => (
                                  <a
                                    target="blank"
                                    href={decoratedHref}
                                    key={key}
                                  >
                                    {decoratedText}
                                  </a>
                                )}
                              >
                                {this.state.projectDetail &&
                                  this.state.projectDetail.project &&
                                  this.state.projectDetail.project.shortBrief &&
                                  !_.isNull(
                                    this.state.projectDetail.project.shortBrief
                                  ) &&
                                  this.state.projectDetail.project.shortBrief
                                    .split("\n")
                                    .map((brief) => (
                                      <>
                                        {convertUnicode(brief)}
                                        <br />
                                      </>
                                    ))}
                              </Linkify>
                            </p>
                          </div>
                          {this.state.projectDetail &&
                            this.state.projectDetail.project &&
                            this.state.projectDetail.project.description && (
                              <>
                                <h5>Detailed Description</h5>
                                <div className="projDetailsDesc">
                                  <div className="editor-text" dangerouslySetInnerHTML={{__html: this.state.projectDetail.project.description}}/>
                                </div>
                              </>
                            )}

                          <div className="pdescattachwrap">
                            {attachments &&
                              attachments.map((value) => {
                                //let file = JSON.parse(unescapeJs(value));
                                return (
                                  <a
                                    href="javascript:void(0)"
                                    className="pdescattachfile"
                                    onClick={(e) => {
                                      isWebView()
                                        ? postMsg("download", value.url)
                                        : this.download_file_pdf(e, value.url);
                                    }}
                                  >
                                    <span>
                                      {/* <i className="iDownloadFile1" /> */}
                                      {getFileIcon(value.name)}
                                      {value.name &&
                                        value.name.substring(
                                          value.name.indexOf("-") + 1
                                        )}
                                    </span>
                                  </a>
                                );
                              })}
                          </div>

                          {role && role.trim() != "type text" && (
                            <>
                              <h5>Roles and Responsibilities</h5>
                              {/* <p dangerouslySetInnerHTML={{
                                    __html: role
                                        ? role
                                            .replace(/&nbsp;/g, ' ')
                                            .replace(/(\r\n|\r|\n)/g, '<br>')
                                        : ''
                                }}/> */}
                              <Linkify
                                componentDecorator={(
                                  decoratedHref,
                                  decoratedText,
                                  key
                                ) => (
                                  <a
                                    target="blank"
                                    href={decoratedHref}
                                    key={key}
                                  >
                                    {decoratedText}
                                  </a>
                                )}
                              >
                                <p>
                                  {role &&
                                    role.split("\n").map((role) => (
                                      <>
                                        {convertUnicode(role)}
                                        <br />
                                      </>
                                    ))}
                                </p>
                              </Linkify>
                            </>
                          )}

                          {qualifications && qualifications.length > 0 && (
                            <>
                              <h5>Qualification</h5>
                              <ul className="ulstyles">
                                {qualifications &&
                                  qualifications.map((qual) => {
                                    return (
                                      <li>
                                        <Linkify
                                          componentDecorator={(
                                            decoratedHref,
                                            decoratedText,
                                            key
                                          ) => (
                                            <a
                                              target="blank"
                                              href={decoratedHref}
                                              key={key}
                                            >
                                              {decoratedText}
                                            </a>
                                          )}
                                        >
                                          {qual &&
                                            qual.split("\n").map((qual) => (
                                              <>
                                                {convertUnicode(qual)}
                                                <br />
                                              </>
                                            ))}
                                        </Linkify>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </>
                          )}

                          <div className="pdincluexclu">
                            <div className="row">
                              {this.state.projectDetail &&
                                this.state.projectDetail.project &&
                                this.state.projectDetail.project.inclusions &&
                                this.state.projectDetail.project.inclusions
                                  .length > 0 &&
                                this.state.projectDetail.project
                                  .inclusions[0] != "" && (
                                  <div className="col-md-6">
                                    <h5>Inclusion</h5>
                                    <Linkify
                                      componentDecorator={(
                                        decoratedHref,
                                        decoratedText,
                                        key
                                      ) => (
                                        <a
                                          target="blank"
                                          href={decoratedHref}
                                          key={key}
                                        >
                                          {decoratedText}
                                        </a>
                                      )}
                                    >
                                      {this.state.projectDetail.project
                                        .inclusions &&
                                        this.state.projectDetail.project.inclusions.map(
                                          (incl) => (
                                            <p>
                                              {incl &&
                                                incl.split("\n").map((incl) => (
                                                  <>
                                                    {convertUnicode(incl)}
                                                    <br />
                                                  </>
                                                ))}
                                            </p>
                                          )
                                        )}
                                    </Linkify>
                                  </div>
                                )}
                              {this.state.projectDetail &&
                                this.state.projectDetail.project &&
                                this.state.projectDetail.project.exclusions &&
                                this.state.projectDetail.project.exclusions
                                  .length > 0 &&
                                this.state.projectDetail.project
                                  .exclusions[0] != "" && (
                                  <div className="col-md-6">
                                    <h5>Exclusion</h5>
                                    <Linkify
                                      componentDecorator={(
                                        decoratedHref,
                                        decoratedText,
                                        key
                                      ) => (
                                        <a
                                          target="blank"
                                          href={decoratedHref}
                                          key={key}
                                        >
                                          {decoratedText}
                                        </a>
                                      )}
                                    >
                                      {this.state.projectDetail.project
                                        .exclusions &&
                                        this.state.projectDetail.project.exclusions.map(
                                          (excl) => (
                                            <p>
                                              {excl &&
                                                excl.split("\n").map((excl) => (
                                                  <>
                                                    {convertUnicode(excl)}
                                                    <br />
                                                  </>
                                                ))}
                                            </p>
                                          )
                                        )}
                                    </Linkify>
                                  </div>
                                )}
                            </div>
                          </div>
                          {this.state.projectDetail &&
                            this.state.projectDetail.project &&
                            this.state.projectDetail.project.endTakeAway && (
                              <>
                                <h5>
                                  {typeContent}
                                  <span>
                                    (Received by participant post completion)
                                  </span>
                                </h5>
                                <Linkify
                                  componentDecorator={(
                                    decoratedHref,
                                    decoratedText,
                                    key
                                  ) => (
                                    <a
                                      target="blank"
                                      href={decoratedHref}
                                      key={key}
                                    >
                                      {decoratedText}
                                    </a>
                                  )}
                                >
                                  <p>
                                    {this.state.projectDetail.project
                                      .endTakeAway &&
                                      this.state.projectDetail.project.endTakeAway
                                        .split("\n")
                                        .map((endTakeAway) => (
                                          <>
                                            {convertUnicode(endTakeAway)}
                                            <br />
                                          </>
                                        ))}
                                  </p>
                                </Linkify>
                              </>
                            )}
                          {this.state.projectDetail &&
                            this.state.projectDetail.project &&
                            this.state.projectDetail.project.mediaAttachments &&
                            this.state.projectDetail.project.mediaAttachments
                              .length > 0 &&
                            this.state.projectDetail.project
                              .mediaAttachments[0] !== "" && (
                              <>
                                <h5>Media Coverage</h5>
                                <ul>
                                  {this.state.projectDetail.project
                                    .mediaAttachments &&
                                    this.state.projectDetail.project.mediaAttachments.map(
                                      (media) => {
                                        return (
                                          <li className="pdtlsLink">
                                            <Linkify
                                              componentDecorator={(
                                                decoratedHref,
                                                decoratedText,
                                                key
                                              ) => (
                                                <a
                                                  target="blank"
                                                  href={decoratedHref}
                                                  key={key}
                                                >
                                                  {decoratedText}
                                                </a>
                                              )}
                                            >
                                              {media &&
                                                media
                                                  .split("\n")
                                                  .map((media) => (
                                                    <>
                                                      {convertUnicode(media)}
                                                      <br />
                                                    </>
                                                  ))}
                                            </Linkify>
                                          </li>
                                        );
                                      }
                                    )}
                                </ul>
                              </>
                            )}

                          {this.state.projectDetail &&
                            this.state.projectDetail.project &&
                            this.state.projectDetail.project.specialization &&
                            this.state.projectDetail.project.skills &&
                            (this.state.projectDetail.project.skills.length >
                              0 ||
                              this.state.projectDetail.project.specialization
                                .length > 0) && (
                              <div className="specialskills">
                                <h5>Skills and Specialization</h5>
                                <div className="specialskillsblk">
                                  {this.state.projectDetail.project
                                    .specialization &&
                                    this.state.projectDetail.project
                                      .specialization.length > 0 && (
                                      <div className="spsktags">
                                        {" "}
                                        {this.state.projectDetail.project
                                          .specialization &&
                                          this.state.projectDetail.project.specialization.map(
                                            (sp) => (
                                              <span>{convertUnicode(sp)}</span>
                                            )
                                          )}{" "}
                                      </div>
                                    )}
                                  {this.state.projectDetail &&
                                    this.state.projectDetail.project &&
                                    this.state.projectDetail.project.skills &&
                                    this.state.projectDetail.project.skills
                                      .length > 0 && (
                                      <div className="spsktags">
                                        {" "}
                                        {this.state.projectDetail.project
                                          .skills &&
                                          this.state.projectDetail.project.skills.map(
                                            (skill) => (
                                              <span>{unescape(skill)}</span>
                                            )
                                          )}{" "}
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                          <div className="pdincluexclu locaduration">
                            {location && location.address && (
                              <>
                                <h5>Detailed Address </h5>
                                <p className="addRss">
                                  <Linkify
                                    componentDecorator={(
                                      decoratedHref,
                                      decoratedText,
                                      key
                                    ) => (
                                      <a
                                        target="blank"
                                        href={decoratedHref}
                                        key={key}
                                      >
                                        {decoratedText}
                                      </a>
                                    )}
                                  >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: linkfiedHtml1,
                                      }}
                                    />
                                  </Linkify>
                                </p>
                              </>
                            )}
                          </div>
                          <div className="pdincluexclu locaduration">
                            <div className="row">
                              <div className="col-md-6">
                                <h5>Duration</h5>
                                <ul>
                                  <li>
                                    <span>Start Date</span>{" "}
                                    {dateUtil.format(
                                      new Date(
                                        this.state.projectDetail &&
                                          this.state.projectDetail.startDate
                                      ),
                                      "DD MMM YYYY"
                                    )}
                                  </li>
                                  {endDate !== "" && (
                                    <li>
                                      <span>End Date</span> {endDate}
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.loginRequired === true ? (
                <AuthModalComponent
                  handleLoginClose={this.handleLoginClose}
                  pathname={this.state.pathname}
                  history={this.props.history}
                />
              ) : null}
              {this.state.signUpRequired === true ? (
                <SignUpModal
                  handleSignUpClose={this.handleSignUpClose}
                  history={this.props.history}
                />
              ) : null}
            </div>
          </div>
        ) : (
          <div className="wrapper projectpage nologinpage">
            <BypassHeader />
            <main className="dgcontainer hm3col">
              <div className="container">
                <div className="row">
                  <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                  <ProjectFeeds
                    key={this.state.projectDetail.projectId}
                    projectDetail={this.state.projectDetail}
                    project={this.state.projectDetail}
                    slug={this.props.match.params.projectId}
                  />
                </div>
              </div>
            </main>
          </div>
        );
      }
    } else {
      return (
        <div className={"projectpage"}>
          <div
            className={
              this.state.notFoundstatusCode === 404 ||
              (this.state.projectDetail &&
                this.state.projectDetail.hidden === true) || (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction)
                ? "wrapper nologinpage staticPage p404"
                : "wrapper"
            }
          >
            {this.state.notFoundStatusCode === 404 ||
            (this.state.projectDetail &&
              this.state.projectDetail.creatorUserId !==
                this.state.userData.userId &&
              this.state.projectDetail.hidden === true) || (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) ? (
              <Header EditedText={true} />
            ) : (
              <Header />
            )}
            {this.state.notFoundstatusCode === 404 ||
            (this.state.projectDetail &&
              this.state.projectDetail.hidden === true) || (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) ? (
              <>
                <main className="dgcontainer hm3col">
                  <div className="container">
                    {this.state.notFoundstatusCode === 404 && this.state.projectDetail.userId != this.state.userData.userId ? <HideInfoPage deletePost={true} /> :
                    (this.state.projectDetail.hidden && (this.state.projectDetail.userId != this.state.userData.userId) && (this.state.projectDetail.creatorUserId != this.state.userData.userId)) ? <PrivateProjectHidePage myStudioPage={true} /> : 
                    (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) ? <PrivateProjectHidePage /> : null}
                  </div>
                </main>
                {!this.state.loginSuccess ? (
                  <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                ) : (
                  <LeftPanel communityActive={this.state.projectDetail?.partyType === "CIRCLE"} />
                )}
                {this.state.loginRequired === true ? (
                  <AuthModalComponent
                    handleLoginClose={this.handleLoginClose}
                    pathname={this.state.pathname}
                    history={this.props.history}
                  />
                ) : null}
                {this.state.signUpRequired === true ? (
                  <SignUpModal
                    handleSignUpClose={this.handleSignUpClose}
                    history={this.props.history}
                  />
                ) : null}
              </>

            ) : (

              <main className="dgcontainer hm3col">
                <div className="container">
                    {this.state.projectResponseMessage === "Success!" && !this.state.projectDetail.myHidden ? <HideInfoPage/> : 
                        <div className="row">
                            <LeftPanel communityActive={this.state.projectDetail?.partyType === "CIRCLE"} />
                            {this.state.projectDetail &&
                            this.state.projectDetail.participationDetails &&
                            this.state.projectDetail.participationDetails
                            .secondaryEntityType &&
                            this.state.projectDetail.participationDetails
                            .secondaryEntityType !== "JOB"
                            ? this.getCentralPanelContent()
                            : this.getCentralPanelContentForJob()}
                        </div>
                    }                  
                </div>
              </main>
            )}
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    applications: state.applications,
    projectPageClickProgress: state.projectPageClickReducer.projectPageClickProgress,
    profileBasicInfoData: state.ProfileReducer.profileBasicInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setApplications: (state) => dispatch(setApplications(state)),
    setParticipants: (state) => dispatch(setParticipants(state)),
    projectPageClickRequest: (state) => dispatch(projectPageClickRequest(state)),
    profileBasicInfo: (state) => dispatch(setProfileBasicInfoDetails(state))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);
